import UserService from '../../services/UserService';
import { getOfficialStyle } from '@/utils/LanguageTypeConversions';
import i18n from '@/i18n';

export const user = {
  namespaced: true,
  state: () => ({
    user: null,
  }),
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async getUser({ commit }) {
      return await UserService.getUser().then((res) => {
        if(res?.data){
          const officialStyle = getOfficialStyle(res?.data?.language);
          i18n.locale = officialStyle;
          commit('SET_USER', res.data);
          return res.data;
        }
      });
    },

    async updateLocale({ commit }, locale){
      return await UserService.updateLocale(locale)
        .then((res) => {
          if(res?.data) {
            const officialStyle = getOfficialStyle(res?.data?.language);
            i18n.locale = officialStyle;
            commit('SET_USER', res.data);
            return res.data;
          }
      });
    },
  },
};
